import {
  closeModal as closeOasisModal,
  openModal,
} from "@risalabs_frontend_org/oasis-ui-kit";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ModalId } from "../../../../../enums/modalId";
import {
  closeModal as closeReduxModal,
  setOpenedModalId,
} from "../../../../../redux/slice/modalSlice";
import type { AppDispatch, RootState } from "../../../../../redux/store/store";
import type { NarAgentGridOrgTab } from "../../narAgentGrid/hooks/useNarAgentGridOrgTabs";
import ConfirmSourceIngestModal from "./confirmSourceIngestModal";
import NeedsReviewModal from "./needsReviewModal";

interface HistoricNarConfigModalHostProps {
  clientOptions: NarAgentGridOrgTab[];
  onIngested: () => void;
}

/** Connect the Redux modal state to the Historic NAR confirmation dialog. */
const HistoricNarConfigModalHost = ({
  clientOptions,
  onIngested,
}: HistoricNarConfigModalHostProps) => {
  const { openedModalId, metaData } = useSelector(
    (state: RootState) => state.modal,
  );
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (openedModalId === ModalId.HISTORIC_NAR_CONFIRM_SOURCE_MODAL) {
      openModal(ModalId.HISTORIC_NAR_CONFIRM_SOURCE_MODAL);
    }
    if (openedModalId === ModalId.NEEDS_REVIEW_MODAL) {
      openModal(ModalId.NEEDS_REVIEW_MODAL);
    }
  }, [openedModalId]);

  const handleClose = () => {
    if (
      openedModalId === ModalId.HISTORIC_NAR_CONFIRM_SOURCE_MODAL ||
      openedModalId === ModalId.NEEDS_REVIEW_MODAL
    ) {
      closeOasisModal(openedModalId);
    }
    dispatch(closeReduxModal());
  };

  /** Preserve the selected recommendation while replacing the active dialog. */
  const handleReIngest = () => {
    closeOasisModal(ModalId.NEEDS_REVIEW_MODAL);
    dispatch(
      setOpenedModalId({
        id: ModalId.HISTORIC_NAR_CONFIRM_SOURCE_MODAL,
        metaData,
      }),
    );
  };

  if (
    openedModalId !== ModalId.HISTORIC_NAR_CONFIRM_SOURCE_MODAL &&
    openedModalId !== ModalId.NEEDS_REVIEW_MODAL
  )
    return null;

  return (
    <>
      {openedModalId === ModalId.HISTORIC_NAR_CONFIRM_SOURCE_MODAL && (
        <ConfirmSourceIngestModal
          metaData={{ clientOptions }}
          onClose={handleClose}
          onIngested={onIngested}
        />
      )}
      {openedModalId === ModalId.NEEDS_REVIEW_MODAL && (
        <NeedsReviewModal
          identifier={metaData?.identifier}
          onClose={handleClose}
          onReIngest={handleReIngest}
        />
      )}
    </>
  );
};

export default HistoricNarConfigModalHost;
